import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { getConfig } from 'tw-oi-core'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  trackBrowseTopicClick,
  trackBrowseFolderClick,
  trackHomeFolderClick,
} from 'tw-oi-core/services/analytics'
import { recalculateTopicsHeightForIOS, getPublicationsForVehicle } from '../extras/utils'
import * as VehicleActions from 'tw-oi-core/actions/VehicleActions'

import { CONTENT_TYPE, DEFAULT_PUBLICATION_TYPE, ROUTE, UI } from '../config'

import ContentList from '../components/ContentList'
import BrowseGuideLayout from '../components/BrowseGuideLayout'
import Loader from '../components/Loader'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import { browseListIcon } from '../components/browseListIcon'
import { isOffline, onConnectivityChange } from '../services/offlineDetect'
import { loadBrowsePage, loadBrowseCategoriesOnly } from '../extras/loadBrowsePage'
import { resolveBrandRouteFromBaseRoute } from '../extras/loadOfflineGuideVehicle'
import { filterItemsByDownloadedCategories } from '../extras/offlineBrowse'

import '../styles/Topics.scss'
import {
  OWNERS_MANUAL_TITLE,
  getRootFolderResourceKey,
  getParentFolder,
  isRootFolder,
  isFolder,
  isCollapsedFolder,
  isDitaTopic,
  getArticlesWithTags,
  getRootLevelArticles,
  getUniqueTags,
  tagToRenderItem,
  containsDita,
  containsArticles,
  containsPdfs,
  containsVideos,
  sortContentsByTitle,
} from '../extras/utils'
import { filteredContents } from './BrandSpecificInformation/BrandSpecificInformation'

class Browse extends Component {
  static propTypes = {
    ownersManualPdfs: ImmutablePropTypes.list,
    fetching: PropTypes.bool,
    contents: PropTypes.shape({
      publications: ImmutablePropTypes.list,
      topics: ImmutablePropTypes.list,
      videos: ImmutablePropTypes.list,
    }),
    publications: ImmutablePropTypes.list,
    topics: ImmutablePropTypes.list,
    folders: ImmutablePropTypes.list,
    foldersIndex: ImmutablePropTypes.map,
    match: PropTypes.object.isRequired,
    baseRoute: PropTypes.string.isRequired,
    brandRoute: PropTypes.string,
    history: PropTypes.object.isRequired,
    vehicle: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    VehicleActions: PropTypes.object.isRequired,
    userMedia: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
    brandSpecificContents: PropTypes.array,
    pubs: PropTypes.array,
    articles: PropTypes.array,
  }

  constructor(props) {
    super(props)

    const { BROWSE_ROOT_KEY } = getConfig()
    const { foldersIndex, topics, baseRoute, match, history, publications } = props
    const rootFolderResourceKey = getRootFolderResourceKey(
      publications,
      DEFAULT_PUBLICATION_TYPE,
      foldersIndex,
      BROWSE_ROOT_KEY
    )
    let folderId = match.params.folderId || rootFolderResourceKey

    let activeFolder = foldersIndex && foldersIndex.size ? foldersIndex.get(folderId) : null
    if (activeFolder && !isFolder(activeFolder.toJS())) {
      let possibleTopic = topics.find(item => item.get('resourceKey') === match.params.folderId)
      if (isCollapsedFolder(activeFolder.toJS()) || (possibleTopic && isDitaTopic(possibleTopic.toJS()))) {
        const url = `${baseRoute}${ROUTE.BROWSE}${ROUTE.TOPIC}/${match.params.folderId}`
        history.replace(url)
        activeFolder = null
      }
    }
    const isActiveFolderRoot = isRootFolder(activeFolder, rootFolderResourceKey)

    this.state = {
      browseReady: !isOffline(),
      offlineMode: isOffline(),
      downloadedCategories: new Set(),
      downloadState: 'none',
      offlineVehicleId: null,
      redirectTo: null,
      activeFolder,
      rootFolderResourceKey,
      isActiveFolderRoot,
      parentFolder: activeFolder && !isActiveFolderRoot ? getParentFolder(activeFolder, foldersIndex) : null,
    }
  }

  componentDidMount() {
    this.initBrowsePage()
    this.unsubscribeConnectivity = onConnectivityChange(this.handleConnectivityChange)
  }

  componentDidUpdate(prevProps) {
    const { rootFolderResourceKey } = this.state

    if (prevProps.baseRoute !== this.props.baseRoute) {
      this.initBrowsePage()
    }

    if (
      this.state.offlineMode &&
      !this.state.browseReady &&
      prevProps.publications !== this.props.publications &&
      this.props.publications
    ) {
      this.initBrowsePage()
    }

    if (
      prevProps.foldersIndex !== this.props.foldersIndex ||
      prevProps.publications !== this.props.publications
    ) {
      const { BROWSE_ROOT_KEY } = getConfig()
      const { foldersIndex, publications } = this.props
      const rootFolderResourceKey = getRootFolderResourceKey(
        publications,
        DEFAULT_PUBLICATION_TYPE,
        foldersIndex,
        BROWSE_ROOT_KEY
      )
      this.setState({ rootFolderResourceKey })
    }

    if (prevProps.match.params.folderId !== this.props.match.params.folderId) {
      const { foldersIndex, match } = this.props

      const folderId = match.params.folderId || rootFolderResourceKey
      const activeFolder = foldersIndex && foldersIndex.size ? foldersIndex.get(folderId) : null
      const isActiveFolderRoot = isRootFolder(activeFolder, rootFolderResourceKey)
      this.setState({
        activeFolder,
        isActiveFolderRoot,
        parentFolder: activeFolder && !isActiveFolderRoot ? getParentFolder(activeFolder, foldersIndex) : null,
      })

      recalculateTopicsHeightForIOS()
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeConnectivity) {
      this.unsubscribeConnectivity()
    }
  }

  handleConnectivityChange = online => {
    this.setState({ offlineMode: !online })
    this.initBrowsePage()
  }

  loadDownloadedCategoryState = async() => {
    const { baseRoute, vehicle } = this.props
    const brandRoute = resolveBrandRouteFromBaseRoute(baseRoute)
    const result = await loadBrowseCategoriesOnly(baseRoute, brandRoute, vehicle.currentBrand)

    if (!result) {
      return {
        downloadedCategories: new Set(),
        downloadState: 'none',
        offlineVehicleId: null,
      }
    }

    return {
      downloadedCategories: result.downloadedCategories || new Set(),
      downloadState: result.downloadState || 'none',
      offlineVehicleId: result.vehicleId || null,
    }
  }

  initBrowsePage = async() => {
    const { baseRoute, vehicle, contents, dispatch, VehicleActions } = this.props
    const brandRoute = resolveBrandRouteFromBaseRoute(baseRoute)
    const requestKey = baseRoute

    if (!isOffline()) {
      try {
        const categoryState = await this.loadDownloadedCategoryState()
        if (this.props.baseRoute !== requestKey) return

        this.setState({
          browseReady: true,
          offlineMode: false,
          redirectTo: null,
          ...categoryState,
        })
      } catch (e) {
        if (this.props.baseRoute !== requestKey) return
        this.setState({
          browseReady: true,
          offlineMode: false,
          redirectTo: null,
          downloadedCategories: new Set(),
          downloadState: 'none',
          offlineVehicleId: null,
        })
      }
      return
    }

    const hasPublications =
      contents.publications &&
      (contents.publications.size > 0 || contents.publications.length > 0)

    if (!hasPublications) {
      this.setState({ browseReady: false, offlineMode: true, redirectTo: null })
    }

    try {
      const result = await loadBrowsePage({
        baseRoute,
        brandRoute,
        vehicle,
        contents,
        dispatch,
        vehicleActions: VehicleActions,
      })

      if (this.props.baseRoute !== requestKey) return

      if (!result.ok) {
        this.setState({ browseReady: true, redirectTo: result.redirect })
        return
      }

      this.setState({
        browseReady: true,
        offlineMode: true,
        redirectTo: null,
        downloadedCategories: result.downloadedCategories || new Set(),
        downloadState: result.downloadState || 'none',
        offlineVehicleId: result.vehicleId || null,
      })
    } catch (e) {
      console.error('[offline] Failed to initialize browse page:', e)
      if (this.props.baseRoute !== requestKey) return
      this.setState({ browseReady: true, redirectTo: ROUTE.OFFLINE })
    }
  }

  trackItem(item) {
    switch (item.type) {
      case CONTENT_TYPE.FOLDER:
        isCollapsedFolder(item) ? trackBrowseTopicClick(item.title) : trackBrowseFolderClick(item.title)
        trackHomeFolderClick(item.title)
        break
      case CONTENT_TYPE.TOPIC:
        trackBrowseTopicClick(item.title)
        break
      default:
    }
  }

  renderMenu = () => {
    const { contents, baseRoute, brandSpecificContents, pubs, articles, ownersManualPdfs } = this.props
    const { rootFolderResourceKey, downloadedCategories } = this.state
    const hasComponentManualOffline = downloadedCategories && downloadedCategories.has('Component Manual')

    if (!contents.publications) return []

    const rootArticles = getRootLevelArticles(articles)
    const articlesUniqTags = getUniqueTags(articles)
    const rootArticlesUniqTags = getUniqueTags(rootArticles)
    const rootMenuItems = rootArticlesUniqTags.map(tagToRenderItem)

    const items = []

    if (containsDita(pubs)) {
      items.push({
        title: OWNERS_MANUAL_TITLE,
        icon: browseListIcon(MenuBookOutlinedIcon),
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.FOLDER}/${rootFolderResourceKey}`,
        type: CONTENT_TYPE.FOLDER,
      })
    } else if (containsArticles(pubs) && articlesUniqTags.includes(OWNERS_MANUAL_TITLE)) {
      items.push({
        title: OWNERS_MANUAL_TITLE,
        icon: browseListIcon(MenuBookOutlinedIcon),
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.TAGS}/${encodeURIComponent(OWNERS_MANUAL_TITLE)}`,
        type: CONTENT_TYPE.FOLDER,
      })
    }

    if (ownersManualPdfs && ownersManualPdfs.size) {
      items.push({
        title: UI.PRINTABLE_OWNERS_MANUAL,
        icon: browseListIcon(PrintOutlinedIcon),
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.PRINTABLE_OWNERS_MANUAL}`,
        type: CONTENT_TYPE.FOLDER,
      })
    }

    if (brandSpecificContents && brandSpecificContents.length) {
      items.push({
        title: 'Brand Specific Information',
        icon: browseListIcon(FolderOutlinedIcon),
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.BRAND_SPECIFIC}`,
        type: CONTENT_TYPE.FOLDER,
      })
    }

    if (containsPdfs(pubs) || hasComponentManualOffline) {
      items.push({
        title: 'Component Manual',
        icon: browseListIcon(PictureAsPdfOutlinedIcon, 'icon-list-pdf'),
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.PDFS}`,
        type: CONTENT_TYPE.FOLDER,
      })
    }

    if (containsVideos(contents)) {
      items.push({
        title: 'Videos',
        icon: browseListIcon(VideocamOutlinedIcon),
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.VIDEOS}`,
        type: CONTENT_TYPE.FOLDER,
      })
    }

    sortContentsByTitle(rootMenuItems).forEach(item => {
      if (item.id) {
        items.push({
          title: item.title,
          icon: browseListIcon(DescriptionOutlinedIcon),
          link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.ARTICLES}${ROUTE.CONTENT}/:${item.resourceKey}`,
          type: CONTENT_TYPE.TOPIC,
        })
      } else {
        items.push({
          title: item.title,
          icon: browseListIcon(FolderOutlinedIcon),
          link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.ARTICLES}/${encodeURIComponent(item.title)}`,
          type: CONTENT_TYPE.FOLDER,
        })
      }
    })

    return items
  }

  render() {
    const { fetching, userMedia, baseRoute, match, ownersManualPdfs, publications } = this.props
    const {
      activeFolder,
      browseReady,
      offlineMode,
      downloadedCategories,
      downloadState,
      offlineVehicleId,
      redirectTo,
    } = this.state
    const isBrowseRoot = !match.params.folderId

    if (redirectTo) {
      return <Redirect to={redirectTo} />
    }

    if (!browseReady) {
      return <Loader className='inverse' />
    }

    if (!activeFolder && !isBrowseRoot) {
      return (
        <Loader type='status' className='inverse'>
          Folder not found
        </Loader>
      )
    }

    const rawMenuItems = this.renderMenu()
    const menuItems = offlineMode
      ? filterItemsByDownloadedCategories(rawMenuItems, downloadedCategories)
      : rawMenuItems

    if (offlineMode && !fetching && rawMenuItems.length === 0) {
      return <Redirect to={ROUTE.OFFLINE} />
    }

    const showContentLoader = !offlineMode && fetching
    const hasPublications =
      publications && (publications.size > 0 || publications.length > 0)

    return (
      <BrowseGuideLayout
        match={match}
        baseRoute={baseRoute}
        ownersManualPdfs={ownersManualPdfs}
        offlineDownloadedCategories={downloadedCategories}
        offlineDownloadState={downloadState}
        offlineVehicleId={offlineVehicleId}
        onOfflineCategoriesChange={this.handleOfflineCategoriesChange}
      >
        {({ onRemoveDownloadedCategory }) => (showContentLoader && !hasPublications ? (
          <Loader className='inverse' />
        ) : (
          <ContentList
            variant='browse-guide'
            isDesktop={userMedia.isDesktop}
            topics={menuItems}
            baseRoute={baseRoute + ROUTE.BROWSE}
            onClick={topic => this.trackItem(topic)}
            downloadedCategories={downloadedCategories}
            onRemoveDownloadedCategory={onRemoveDownloadedCategory}
          />
        ))}
      </BrowseGuideLayout>
    )
  }

  handleOfflineCategoriesChange = ({ downloadedCategories, downloadState, offlineVehicleId }) => {
    this.setState(prev => ({
      downloadedCategories: downloadedCategories !== undefined
        ? (downloadedCategories instanceof Set ? new Set(downloadedCategories) : new Set())
        : prev.downloadedCategories,
      downloadState: downloadState !== undefined ? downloadState : prev.downloadState,
      offlineVehicleId: offlineVehicleId !== undefined
        ? (offlineVehicleId != null ? String(offlineVehicleId) : null)
        : prev.offlineVehicleId,
    }))
  }
}

function mapStateToProps({ contents, vehicle, user }) {
  const { topics, folders, foldersIndex, publications, fetching, currentAsset, fetchingAsset, currentFolder } = contents
  const { currentYear, currentModel, currentBrand } = vehicle
  const { media: userMedia } = user

  const processedContents = filteredContents(contents)
  const pubs = getPublicationsForVehicle(processedContents.publications)
  const articles = getArticlesWithTags(pubs)

  return {
    contents: processedContents,
    topics,
    folders,
    foldersIndex,
    publications,
    fetching,
    currentAsset,
    fetchingAsset,
    currentYear,
    currentModel,
    currentBrand,
    currentFolder,
    userMedia,
    brandSpecificContents: processedContents.brandSpecificContents,
    pubs,
    articles,
    vehicle,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    VehicleActions: bindActionCreators(VehicleActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Browse)
